import { render, staticRenderFns } from "./StatTile.vue?vue&type=template&id=4615ce0e&scoped=true"
import script from "./StatTile.vue?vue&type=script&lang=js"
export * from "./StatTile.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=4615ce0e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4615ce0e",
  null
  
)

export default component.exports